$(document).ready(function() {
    $("input[type='radio']").click(function() {
        var goldRadioValue = $("input[name='metal']:checked").val();
        $(".ksoGoldColor").html(goldRadioValue);
        if (goldRadioValue != "Blackened Gold") {
            $(".ksoGoldPhrase").html(goldRadioValue);
        }
        else {
            $(".ksoGoldPhrase").html("White Gold with Black Rhodium");
        }
    });
    $("input[type='radio']").click(function() {
        var goldRadioValue = $("input[name='metal']:checked").val();
        $("#ksoGoldColor").html(goldRadioValue);
        if (goldRadioValue != "Blackened Gold") {
            $("#ksoGoldPhrase").html(goldRadioValue);
        }
        else {
            $("#ksoGoldPhrase").html("White Gold with Black Rhodium");
        }
    });
    $("input[type='radio']").click(function() {
        var goldRadioValue = $("input[name='Metal']:checked").val();
        $(".goldColor").html(goldRadioValue);
        if (goldRadioValue != "Blackened Gold") {
            $(".goldPhrase").html(goldRadioValue);
        }
        else {
            $(".goldPhrase").html("White Gold with Black Rhodium");
        }
    });
  $("input[name='Metal']").each(function () {
   
    const isChecked = $(this).attr('checked');
    if(isChecked){

        const value = $(this).attr('value');
        $('.goldColor').html(value);
    }
});
});

    var selectCallback = function(variant, selector) {

        if (variant) {
          $('.variant-sku').text(variant.sku);
        }
        else {
          $('.variant-sku').empty();
        }

        self.productPage({
          money_format: theme.moneyFormat,
          variant: variant,
          selector: selector,
          translations: {
            add_to_cart : theme.productStrings.addToCart,
            sold_out : theme.productStrings.soldOut,
            unavailable : theme.productStrings.unavailable
          }
        });
      }; 



$(".sortOption").click(function(){
  var sortText = $(this).text();
  $("#sortText").text(sortText);
});